interface Props {
  message: string;
}

const ErrorMessage = ({ message }: Props) => {
  return <div className="gpc__error-message">{message}</div>;
};

export default ErrorMessage;
